import {
    GetStatusConfig,
    PAYMENT_STATUS_VARIANT,
    PROMOTION_TYPE_COLOR_FALLBACK,
    PROMOTION_TYPE_COLORS,
} from '../utils/status';
import Badge from './ui/Badge';

/**
 * Badge de status por domínio — renderização única dos mapas de `utils/status.js`.
 *
 *   <StatusBadge domain="promotion" status="started" />
 *   <StatusBadge domain="promotionType" status="DEAL" />
 *   <StatusBadge domain="wms" status="picking" />
 *   <StatusBadge domain="payment" status="approved" />
 *
 * - `promotion`/`wms`: pill com ícone + label (cores do mapa do domínio).
 * - `promotionType`: pill com o próprio tipo como texto.
 * - `payment`: delega pro `ui/Badge` com a variant do status.
 */
const StatusBadge = ({ domain, status, className = '' }) => {
    if (domain === 'payment') {
        return <Badge variant={PAYMENT_STATUS_VARIANT[status] || 'default'}>{status || '-'}</Badge>;
    }

    if (domain === 'promotionType') {
        return (
            <span
                className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                    PROMOTION_TYPE_COLORS[status] || PROMOTION_TYPE_COLOR_FALLBACK
                } ${className}`}
            >
                {status || '-'}
            </span>
        );
    }

    const config = GetStatusConfig(domain, status);
    if (!config) {
        return <span className={className}>{status || '-'}</span>;
    }

    const Icon = config.icon;
    const padding = domain === 'wms' ? 'gap-1.5 px-2.5 py-0.5' : 'gap-1 px-2 py-1';

    return (
        <span className={`inline-flex items-center rounded-full text-xs font-medium ${padding} ${config.color} ${className}`}>
            {Icon ? <Icon size={14} weight="fill" /> : null}
            {config.label}
        </span>
    );
};

export default StatusBadge;
